<template>
  <v-row>
    <!-- header -->
    <mini-header title="Reportes" :dense="true" :breadcrumbs="breadcrumbs" :hiddenTab="true" />
    <!-- end header -->
      <v-col cols="12" class="px-0 mt-5">
        <v-row v-if="reportsList.length">
          <v-col cols="2" style="max-width: 240px;" v-for="(report, i) in reportsList" :key="i">
            <v-card class="px-5 py-7" @click="goToReport(report)" height="80" min-width="220" max-width="220">
              <v-row class="fill-height ma-0 text-left" align="center">
                <v-img contain :height="44" style="position: absolute" :src="require(`@/assets/shortcuts-icons/avatars/${report.icon}--avatar.svg`)" />
                <span class="grey-700--text font-weight-bold ml-14 pl-2 mt-n1" :class="$vuetify.breakpoint.width <= 1200 ? 'body-2' : 'subtitle-2'">{{ report.title }}</span>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-empty-state v-else type="documents" id="reportes" :height="320" customClass="mt-8" :isFree="true" title="No tienes reportes disponibles" description="No cuentas con permisos para visualizar reportes o no hay reportes disponibles para tu país" />
      </v-col>
  </v-row>
</template>
<script>
import MiniHeader from '@/components/commons/MiniHeader'
import VEmptyState from '@/components/commons/VEmptyState'

export default {
  components: {
    MiniHeader,
    VEmptyState
  },
  data () {
    return {
      breadcrumbs: {
        main: 'Emisión',
        children: [
          {
            text: 'Reportes'
          }
        ]
      },
      allReports: [
        {
          title: 'SIRE',
          icon: 'documents',
          routeName: 'SireList',
          use: ['PE'],
          permission: 'download_sire'
        },
        {
          title: 'Detalle de ventas diarias',
          icon: 'reports',
          routeName: 'SalesReportDetail',
          use: ['CL', 'PE'],
          permission: 'download_sales_report'
        }
      ]
    }
  },
  computed: {
    currentParams () {
      let params = JSON.parse(JSON.stringify(this.$route.params))
      delete params.id
      return params
    },
    reportsList () {
      const country = this.$store.state.auth.account.country
      return this.allReports.filter(report => {
        if (!report.use.includes(country)) return false
        if (report.permission) return this.$helpers.hasSomePermission([report.permission])
        return true
      })
    }
  },
  methods: {
    goToReport (report) {
      this.$router.push({ name: report.routeName, params: this.currentParams })
    }
  }
}
</script>
